import { get } from 'dpl/shared/utils/object';

export default function isFeatureEnabled(name) {
  if (CONFIG.isDevelopment && !Object.hasOwnProperty.call((window.__DPL_FEATURES || {}), name)) {
    window.console.warn(`[${name}] is not a valid feature flag.`);
  }

  return get(window.__DPL_FEATURES, name, false);
}
